import React from 'react';
import { Tab, TabProps } from 'semantic-ui-react';

import { useURLState } from 'src/hooks';

export type Props = {
  onChange?: (data) => void;
  indexName?: string;
  defaultKey?: string;
};

const CustomTab: React.FC<TabProps & Props> = (props) => {
  const { onChange, indexName = 'tab', panes = [], defaultKey } = props;
  const [urlState, setUrlState] = useURLState<any>({
    [indexName]: defaultKey || panes[0]?.menuItem?.key || '',
  });

  const onTabChange = (e, d) => {
    const tabOfCurrentData = panes[d.activeIndex]?.menuItem?.key || '';
    setUrlState({ ...urlState, [indexName]: tabOfCurrentData });

    onChange?.(d);
  };

  return (
    <Tab
      className="custom_tab"
      menu={{ secondary: true, pointing: true }}
      panes={panes}
      activeIndex={props.panes?.findIndex(
        (pane) => pane.menuItem?.key === urlState.tab,
      )}
      onTabChange={onTabChange}
      {...props}
    />
  );
};

export default CustomTab;
